import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { productCategoryMappingInfo } from 'app/utilities/Utils';
import SEOCategoryContent from '../SEOCategoryContent';

function CategorySeoMetaData(props) {
  const { selectedCategory } = props;
  return (
    <Container
      className="bg-light"
    >
      {
        selectedCategory
        && selectedCategory.categoryMetaData
        && selectedCategory.categoryMetaData.length === 0
        && !!productCategoryMappingInfo(selectedCategory || {}).h1 && (
          <Row>
            <Col
              xs={24}
              className="bg-light py-3"
            >
              <h1 className="my-0 text-gray-light">{productCategoryMappingInfo(selectedCategory || {}).h1}</h1>
            </Col>
          </Row>
        )
      }
      {
        selectedCategory
        && selectedCategory.categoryMetaData
        && selectedCategory.categoryMetaData.length > 0
        && (
          <Row>
            <Col
              xs={24}
              className="bg-light text-gray-light py-3"
            >
              {
                selectedCategory.categoryMetaData.map((metaData) => (
                  <SEOCategoryContent
                    content={metaData}
                  />
                ))
              }
            </Col>
          </Row>
        )
      }
      {
        selectedCategory
        && selectedCategory.categoryMetaData
        && selectedCategory.categoryMetaData.length === 0
        && selectedCategory.categoryDetailDescription
        && (
          <Row>
            <Col
              xs={24}
              className="bg-light fs-5 text-gray-light py-3"
            >
              {selectedCategory.categoryDetailDescription}
            </Col>
          </Row>
        )
      }
    </Container>
  );
}

CategorySeoMetaData.propTypes = {
  selectedCategory: PropTypes.shape({
    categoryMetaData: PropTypes.arrayOf(PropTypes.shape({})),
    categoryDetailDescription: PropTypes.string,
  }).isRequired,
};

export default CategorySeoMetaData;
